import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HeadingSize, HeadingType } from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';

@Component({
  template: `
    <fl-heading
      i18n="Modal heading for allowing Freelancer.com to access the user's camera"
      [size]="HeadingSize.XSMALL"
      [headingType]="HeadingType.H4"
      [flMarginBottom]="Margin.SMALL"
    >
      Allow Freelancer.com to use your camera
    </fl-heading>
    <fl-text
      i18n="Inform user that Freelancer.com needs camera access to take pictures for required documents"
      [flMarginBottom]="Margin.SMALL"
    >
      Freelancer.com needs access to your camera to take pictures of your
      required documents.
    </fl-text>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrowserPermissionModalComponent {
  Margin = Margin;
  HeadingSize = HeadingSize;
  HeadingType = HeadingType;
}
